module.exports = __webpack_public_path__ + "static/media/success-logo.c0ccdf50.svg";